import Grid from '@mui/material/Grid';
import PageTitle from 'src/components/PageTitle';
import MigrationPanel from './MigrationPanel';

function MigrationDashboard() {
  return (
    <>
      <PageTitle />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MigrationPanel />
        </Grid>
      </Grid>
    </>
  );
}

export default MigrationDashboard;
